import { PROCESS_STATUS } from '@plataforma/utils';
import {
  formatDate,
  getTotalInDays,
  getDuration,
  formatCurrency,
  formatCnpjCpf,
  formatPercent,
  processNumber
} from '../utils';

function formatEndorsements(endorsements) {
  return endorsements.map(endorsement => ({
    typeDescription: endorsement.typeDescription,
    createdAt: formatDate(endorsement.createdAt),
    sendedEmail: endorsement.sendedEmail,
    includedLogin: endorsement.includedLogin,
    internalized: endorsement.internalized,
    automaticEmission: endorsement.automaticEmission,
    requestEmission: endorsement.requestEmission,
    requestEmissionDate: endorsement.requestEmissionDate,
    status: endorsement.status,
    statusDescription: endorsement.statusDescription,
    regionalEmail: endorsement.regionalEmail,
    deleted: endorsement.deleted,
    type: endorsement.type,
    documentNumber: endorsement.documentNumber,
    policyNumber: endorsement.policyNumber
  }));
}

function formatQuoteStatus(quoteStatus) {
  const processStatusArray = Object.values(PROCESS_STATUS);
  return processStatusArray.find(status => status.id === Number(quoteStatus));
}

function formatProcess(process) {
  return { ...process, processId: String(process.processId) };
}

function getProtocolToBeDisplayed(protocols) {
  if (protocols.length < 2) {
    return protocols[0].text;
  }

  return protocols.find(protocol => protocol.text.includes('Contratada')).text;
}

function buildData(document) {
  // Data to ProcessDetails
  const duration = getDuration(document.durationStart, document.durationEnd);
  const totalIndays = getTotalInDays(
    document.durationStart,
    document.durationEnd
  );
  const endorsements = document.endorsements
    ? formatEndorsements(document.endorsements)
    : [];
  const process = processNumber(document);
  const hasRestrictedAccess = !!document.quoteDetailsRestrictAccess;
  const detail = hasRestrictedAccess
    ? {
        ...document.quoteDetailsRestrictAccess,
        documentNumber: String(document.documentNumber),
        endorsements,
        hasRestrictedAccess,
        process: formatProcess(process),
        quoteStatus: formatQuoteStatus(document.quoteStatus)
      }
    : {
        actionStep: document.actionStep,
        claimant: document.claimant,
        commissionValue: document.commissionValue
          ? formatCurrency(document.commissionValue)
          : null,
        cpfClaimant: document.cpfClaimant,
        customerControlIdentifies: document.customerControlIdentifies,
        description: document.description,
        documentNumber: String(document.documentNumber),
        taxValue: document.rate ? formatPercent(document.rate) : null,
        duration: `${duration} (${String(totalIndays)} dias)`,
        durationEnd: document.durationEnd
          ? formatDate(document.durationEnd)
          : null,
        durationStart: document.durationStart
          ? formatDate(document.durationStart)
          : null,
        edital: document.edital,
        endorsements,
        federalId: formatCnpjCpf(document.federalId),
        hasRestrictedAccess,
        id: document.id,
        insuredName: document.insuredName,
        isExpress: document.isExpress,
        issuedAt: document.issuedAt ? formatDate(document.issuedAt) : null,
        modalityId: document.modalityId,
        name: document.name,
        observation: document.observation,
        policyNumber: String(document.policyNumber),
        process: formatProcess(process),
        quoteStatus: formatQuoteStatus(document.quoteStatus),
        securedAmount: formatCurrency(document.securedAmount),
        subModalityId: document.subModalityId,
        totalPremiumValue: formatCurrency(document.totalPremiumValue),
        protocol: document.protocols
          ? getProtocolToBeDisplayed(document.protocols)
          : ''
      };

  return detail;
}

export default function documentDataPresenter({ data, status }) {
  const documentData = buildData(data);
  return {
    status,
    data: documentData
  };
}
